import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ClientLayout from './layouts/ClientLayout'
import { useAuth } from './contexts/AuthContext'
import './App.css'

const Home = lazy(() => import('./pages/Home'))
const Projects = lazy(() => import('./pages/Projects'))
const ProjectDetail = lazy(() => import('./pages/ProjectDetail'))
const Packages = lazy(() => import('./pages/Packages'))
const Finance = lazy(() => import('./pages/Finance'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const Requirements = lazy(() => import('./pages/Requirements'))
const Login = lazy(() => import('./pages/Login'))
const Register = lazy(() => import('./pages/Register'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const BusinessSetup = lazy(() => import('./pages/BusinessSetup'))
const ProfileManagement = lazy(() => import('./pages/ProfileManagement'))
const Settings = lazy(() => import('./pages/Settings'))
const MyOrders = lazy(() => import('./pages/MyOrders'))
const OrderDetail = lazy(() => import('./pages/OrderDetail'))
const CustomInvoiceCheckout = lazy(() => import('./pages/CustomInvoiceCheckout'))
const PackageInquiriesPage = lazy(() => import('./pages/PackageInquiriesPage'))
const NotFound = lazy(() => import('./pages/NotFound'))

function RouteFallback() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
            Loading...
        </div>
    )
}

function ProtectedRoute() {
    const { isAuthenticated, authLoading } = useAuth()

    if (authLoading) {
        return <RouteFallback />
    }

    return isAuthenticated ? <ClientLayout /> : <Navigate to="/login" replace />
}

function App() {
    return (
        <Suspense fallback={<RouteFallback />}>
            <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/business-setup" element={<BusinessSetup />} />

                <Route element={<ProtectedRoute />}>
                    <Route path="/home" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/projects/:id" element={<ProjectDetail />} />
                    <Route path="/packages" element={<Packages />} />
                    <Route path="/finance" element={<Finance />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/requirements" element={<Requirements />} />
                    <Route path="/my-orders" element={<MyOrders />} />
                    <Route path="/orders/:orderId" element={<OrderDetail />} />
                    <Route path="/orders/accept/:token" element={<CustomInvoiceCheckout />} />
                    <Route path="/quotations/accept/:token" element={<CustomInvoiceCheckout />} />
                    <Route path="/profile" element={<ProfileManagement />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/messages" element={<PackageInquiriesPage />} />
                </Route>

                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
        </Suspense>
    )
}

export default App
